import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedMutation, makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { AcceptConsentErrors, AcceptConsentResult } from '../consent/codecs';
export var useConsentStatusQuery = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query ConsentStatus {\n      consentStatus\n    }\n  "]))), t.type({
  consentStatus: t["boolean"]
}));
export var useAcceptConsent = makeDecodedMutation(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation AcceptConsent($input: AcceptConsentInput!) {\n      acceptConsent(input: $input) {\n        ... on AcceptConsentResult {\n          consentStatus\n        }\n        ... on AcceptConsentErrors {\n          __typename\n        }\n      }\n    }\n  "]))), t.type({
  acceptConsent: nullable(t.union([AcceptConsentResult, AcceptConsentErrors]))
}), t.type({
  input: t.type({
    fields: nullable(t.array(t.type({
      id: t.string,
      accepted: t["boolean"]
    }))),
    receiveEmailNotification: nullable(t["boolean"])
  })
}));